<app-header
  [transparent]="false"
  [title]="!!telemetry ? i18n.parse(telemetry.title) : ''"
></app-header>
@if (!!loading) {
  <div class="spinner-container" [class.desktop]="isDesktop">
    <app-spinner [black]="true"></app-spinner>
  </div>
}

<div class="content" [class.desktop]="isDesktop">
  @if (isDesktop) {
    <div class="desktop-sidebar white-sidebar">
      <app-sidebar
        [showList]="true"
        [asset]="asset4Sidebar"
        [loading]="loading"
        [sensorHealthPage]="IsSensorHealth"
        [telemetry]="telemetry"
      ></app-sidebar>
    </div>
  }

  @if (!!asset && !loading) {
    <div
      [class.desktop-main]="isDesktop"
      [class.white-sidebar-main]="isDesktop"
    >
      @if (!isDesktop && !!asset && asset.breadcrumbs && !breadcrumbsLoading) {
        <app-breadcrumbs
          [array]="Breadcrumbs"
          [isAsset]="true"
          class="detail-bold"
        ></app-breadcrumbs>
      }
      @if (isDesktop) {
        <div class="asset-back-btn" (click)="goBack()">
          <i nz-icon nzType="icons:arrow-left" class="svg-icon fillwhite"></i>
          <span>{{
            i18n.langString("back_to") +
              (IsSensorHealth
                ? i18n.langString("edge_device_health")
                : i18n.parse(this.asset.objectName))
          }}</span>
        </div>
      }

      @if (documentationAdded) {
        <div class="ga-documentation-note body-bold">
          <i nz-icon nzType="icons:done" class="svg-icon"></i>
          <span>{{ i18n.langString("add_documentation_success") }}</span>
        </div>
      }

      @if (asset.notifications.length && !isOfEdgeDevice) {
        <div class="crit-alert">
          @for (notification of asset?.notifications; track $index) {
            <ng-container>
              @if (
                sensor?.measurementID === notification?.measurementTypeID &&
                sensor?.sensorID === notification?.sensorID
              ) {
                <app-notification-alert
                  [notificationList]="false"
                  [notification]="notification"
                ></app-notification-alert>
              }
            </ng-container>
          }
        </div>
      }

      @if (telemetry) {
        <div [class.isOfEdgeDevice]="isOfEdgeDevice">
          <div class="sensor-header flat-sensor">
            <i
              nz-icon
              [nzType]="'icons:' + telemetry.svg"
              class="sensor-icon svg-icon"
            ></i>
            <div class="sensor-header-inner-div">
              @if (!isOfEdgeDevice) {
                <h2>{{ i18n.parse(Title) }}</h2>
              }
              @if (isOfEdgeDevice) {
                <h2>
                  {{ i18n.parse(Title) }}
                  {{ i18n.langString("of_the_edge_device") }}
                </h2>
              }

              @if (!isOfEdgeDevice) {
                <span class="detail lighter-label">{{
                  sensor.sensorDisplayLabel
                }}</span>
              }
            </div>
          </div>
          @if (DisplayErrorCard && telemetry.critical) {
            <div class="error-card">
              <span class="error-card-title">{{
                i18n.langString("problem_detected_title")
              }}</span>
              <div
                class="error-card-content"
                [class.hasEdgeDeviceButton]="ErrorCardHasReplaceButton"
              >
                <i
                  nz-icon
                  nzType="icons:status-exclamation-triangle"
                  class="svg-icon fillwhite"
                ></i>
                <span class="error-card-text">
                  {{ ErrorCardText }}
                </span>
              </div>
              @if (ErrorCardHasReplaceButton) {
                <app-nav-button
                  [href]="InstallationAgentURL"
                  [primary]="true"
                  svgIcon="icons:edge_device"
                >
                  {{ i18n.langString("replace_edge_device_button") }}
                </app-nav-button>
              }
            </div>
          }

          @if (DisplayErrorCard && telemetry.warning) {
            <div class="error-card warning">
              <span class="error-card-title warning">{{
                i18n.langString("problem_detected_title")
              }}</span>
              <div
                class="error-card-content"
                [class.hasEdgeDeviceButton]="ErrorCardHasReplaceButton"
              >
                <i
                  nz-icon
                  nzType="icons:status-exclamation-octagon"
                  class="svg-icon mini-svg-icon left-icon"
                ></i>
                <span class="error-card-text warning">
                  {{ ErrorCardText }}
                </span>
              </div>
              @if (ErrorCardHasReplaceButton) {
                <app-nav-button
                  [href]="InstallationAgentURL"
                  [primary]="true"
                  svgIcon="icons:edge_device"
                >
                  {{ i18n.langString("replace_edge_device_button") }}
                </app-nav-button>
              }
            </div>
          }

          <div class="sensordata-wrapper">
            <app-sensor-value
              [telemetry]="telemetry"
              [asHeader]="true"
            ></app-sensor-value>
            <div class="grapharea-wrapper">
              <app-tab-bar
                [opaque]="true"
                [icon]="false"
                (tabChanged)="onTelemetryTimeframeSelect($event)"
                [disabled]="noDataTelemetry() || Timeframe.custom"
              >
                <app-tab-bar-item
                  class="one-of-three"
                  [inactive]="isTelemetryTimeframeCustom()"
                  >{{ i18n.langString("days") }}
                </app-tab-bar-item>
                <app-tab-bar-item
                  class="one-of-three"
                  [inactive]="isTelemetryTimeframeCustom()"
                  >{{ i18n.langString("weeks") }}
                </app-tab-bar-item>
                <app-tab-bar-item
                  class="one-of-three"
                  [inactive]="isTelemetryTimeframeCustom()"
                  >{{ i18n.langString("months") }}
                </app-tab-bar-item>
              </app-tab-bar>
              @for (data of VisibleTelemetryGraphs; track $index) {
                <div>
                  @if (data?.openRangePicker > 0) {
                    <div
                      class="range-picker-backdrop"
                      (click)="cancelRangePick(data)"
                    ></div>
                  }

                  <div
                    class="range-picker-wrapper"
                    [class.disabled]="noData(data)"
                  >
                    @if (isDesktop) {
                      <ng-container>
                        <nz-range-picker
                          [nzShowToday]="false"
                          [nzAllowClear]="false"
                          [nzPlaceHolder]="[
                            i18n.langString('start'),
                            i18n.langString('end'),
                          ]"
                          [nzDisabledDate]="rangePickerDisabledDate(data, 1)"
                          #datePick
                          [(ngModel)]="range"
                          [id]="
                            'picker_start_' + data.metadata.measurementTypeID
                          "
                          (ngModelChange)="onRangePickerSelect($event)"
                        >
                        </nz-range-picker>
                      </ng-container>
                    } @else {
                      <ng-template #mobileDatePicker>
                        <nz-date-picker
                          [nzShowToday]="false"
                          [nzAllowClear]="false"
                          #datePick
                          [id]="
                            'picker_start_' + data?.metadata?.measurementTypeID
                          "
                          [nzDisabledDate]="rangePickerDisabledDate(data, 1)"
                          [(ngModel)]="range[0]"
                          (ngModelChange)="
                            onRangeStartPick(
                              data.metadata.measurementTypeID,
                              sensor.sensorID,
                              $event,
                              'picker_end_' + data.metadata.measurementTypeID,
                              data
                            )
                          "
                        >
                        </nz-date-picker>
                        <nz-date-picker
                          [nzShowToday]="false"
                          [nzAllowClear]="false"
                          #datePick
                          [id]="'picker_end_' + data.metadata.measurementTypeID"
                          [nzDisabledDate]="rangePickerDisabledDate(data, 2)"
                          [(ngModel)]="range[1]"
                          (ngModelChange)="
                            onRangeEndPick(
                              data.metadata.measurementTypeID,
                              sensor.sensorID,
                              $event,
                              data
                            )
                          "
                        >
                        </nz-date-picker>
                        <button>
                          <span
                            [class.active]="data.openRangePicker === 1"
                            (click)="
                              openRangePicker(
                                'picker_start_' +
                                  data.metadata.measurementTypeID,
                                data
                              )
                            "
                            >{{ range[0] | date }}</span
                          >
                          -
                          <span
                            [class.active]="data.openRangePicker === 2"
                            (click)="
                              openRangePicker(
                                'picker_end_' + data.metadata.measurementTypeID,
                                data
                              )
                            "
                            >{{ range[1] | date }}</span
                          >
                          <i
                            nz-icon
                            nzType="icons:edit"
                            class="sensor-icon svg-icon"
                            (click)="
                              openRangePicker(
                                'picker_start_' +
                                  data.metadata.measurementTypeID,
                                data
                              )
                            "
                            [class.fillgrey]="noData(data)"
                          ></i>
                        </button>
                      </ng-template>
                    }
                  </div>
                  <div class="graph-wrapper">
                    @if (!!data.loading) {
                      <app-spinner [black]="true"></app-spinner>
                    }

                    @if (!error) {
                      <app-graph
                        [Data]="data"
                        [class.hidden]="!!data.loading"
                        [Timeframe]="timeframe"
                        [Settings]="settings"
                        Type="line"
                        (timeframeReset)="resetTimeframeSelect()"
                      ></app-graph>
                    }

                    @if (!data.loading && !!error) {
                      <span class="error">{{
                        i18n.langString("error_loading_data")
                      }}</span>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (sensor && !isOfEdgeDevice && false) {
        <div class="history-wrapper">
          <div class="sensor-header flat-sensor">
            <i nz-icon nzType="icons:history" class="sensor-icon svg-icon"></i>
            <div class="sensor-header-inner-div">
              <h2>{{ i18n.langString("history") }}</h2>
              <span class="detail lighter-label">{{
                sensor.sensorDisplayLabel
              }}</span>
            </div>
          </div>
          <div class="history">
            <nz-list nzBordered [nzFooter]="historyfooter" class="history-list">
              @for (item of historyItems.slice(0, 6); track $index) {
                <nz-list-item>
                  <app-history-item
                    [dateFormat]="settings.DateFormat"
                    [item]="item"
                    [asset]="asset"
                  >
                  </app-history-item>
                </nz-list-item>
              }
            </nz-list>

            <ng-template #historyfooter>
              <div class="history-footer-item">
                <app-nav-button
                  [primary]="true"
                  svgIcon="icons:eye"
                  [disabled]="!historyItems || historyItems.length === 0"
                  (clickEvent)="
                    toSensorHistory(
                      sensor.sensorID,
                      telemetry.measurementTypeID
                    )
                  "
                >
                  {{ i18n.langString("show_all_entries") }}</app-nav-button
                >
              </div>
              <div class="history-footer-item">
                <app-nav-button
                  [darksecondary]="true"
                  svgIcon="icons:documentation"
                  (clickEvent)="overlayDocumentation = true"
                >
                  {{ i18n.langString("add_documentation") }}</app-nav-button
                >
                @if (overlayDocumentation) {
                  <app-docu-wizard
                    (saved)="onDocumentationAdded()"
                    [assetId]="assetID"
                    [sensorId]="sensorID"
                    (closeEvent)="overlayDocumentation = false"
                  ></app-docu-wizard>
                }
              </div>
            </ng-template>
          </div>
        </div>
      }

      @if (IsSensorHealth) {
        <div class="location-wrapper">
          <div class="sensor-header">
            <i nz-icon nzType="icons:location" class="sensor-icon svg-icon"></i>
            <h2>{{ i18n.langString("location") }}</h2>
          </div>
          @if (breadcrumbsLoading) {
            <div class="location-spinner-container">
              <app-spinner [black]="true"></app-spinner>
            </div>
          }

          <div class="location-content">
            @if (breadcrumbsLoading) {
              <div class="location-spinner-container">
                <app-spinner [black]="true"></app-spinner>
              </div>
            }

            @if (asset.breadcrumbs && !breadcrumbsLoading) {
              <nz-descriptions
                [nzColumn]="1"
                nzBordered
                [nzSize]="'small'"
                class="nzNotATable"
              >
                @for (breadcrumb of asset.breadcrumbs; track $index) {
                  <ng-container>
                    @if ($index > 0) {
                      <nz-descriptions-item
                        [nzTitle]="i18n.parse(breadcrumb.layerName)"
                      >
                        <span
                          [class.clickable]="isBreadcrumbClickable()"
                          (click)="navToBreadcrumb(breadcrumb)"
                          >{{ i18n.parse(breadcrumb.objectName) }}
                        </span>
                      </nz-descriptions-item>
                    }
                  </ng-container>
                }
              </nz-descriptions>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
